import React from 'react'

function S3Uploads() {
    return (
        <div className='s3uploads'>
            <h3>S3 Uploads (Coming soon..)</h3>
        </div>
    )
}

export default S3Uploads
